import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Flex,
  Input,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Spinner,
} from '@chakra-ui/react';
import toast from 'react-hot-toast';
import { AddIcon } from '@chakra-ui/icons';
import { useHistory } from 'react-router-dom';

const TemplateList = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const res = await axios.get(
          'https://bounce.mailamp.in/campaign/html/templates',
        );
        console.log('🚀 ~ fetchTemplates ~ res:', res);
        setTemplates(res.data.data);
      } catch (error) {
        console.log('🚀 ~ fetchTemplates ~ error:', error);
        const errorMessage = error.response.data.message;
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  const handleCreateCampaign = (templateId, templateName) => {
    console.log('🚀 ~ handleCreateCampaign ~ templateId:', templateId);
    history.push({
      pathname: `/admin/create-campaign/${templateId}`,
      state: { templateName, templateId },
    });
  };
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Box mt={5} bg="white" p={4} borderRadius="lg" boxShadow="md">
        {/* <Flex mb={4} justify="center" align="center">
          <Input
            placeholder="Filter templates..."
            maxW="200px"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <IconButton aria-label="Search" icon={<SearchIcon />} />
        </Flex> */}
        {loading ? (
          <Flex justify="center" align="center">
            <Spinner size="xl" />
          </Flex>
        ) : (
          <Table variant="simple">
            <Thead bgColor="#f4f4f4">
              <Tr>
                <Th>No.</Th>
                <Th>Template Name</Th>
                <Th>Date Created</Th>
                <Th>Create Campaign</Th>
              </Tr>
            </Thead>
            <Tbody>
              {templates?.map((template, index) => (
                <Tr key={template._id}>
                  <Td>{index + 1}</Td>
                  <Td>{template.name}</Td>
                  <Td>{new Date(template.createdAt).toLocaleDateString()}</Td>
                  <Td>
                    <IconButton
                      onClick={() =>
                        handleCreateCampaign(template._id, template.name)
                      }
                      aria-label="Create Campaign"
                      icon={<AddIcon />}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </Box>
    </Box>
  );
};

export default TemplateList;
